import { render } from "./OrderChangeActivityBadge.vue?vue&type=template&id=b0ad079a&scoped=true"
import script from "./OrderChangeActivityBadge.vue?vue&type=script&lang=js"
export * from "./OrderChangeActivityBadge.vue?vue&type=script&lang=js"

import "./OrderChangeActivityBadge.vue?vue&type=style&index=0&id=b0ad079a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b0ad079a"

export default script